import cs from './cs.js'

export default {
  cs
}
